(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }
  customElements.define('cart-note', CartNote);

  // VAT Relief Checkbox Handler
  document.addEventListener('DOMContentLoaded', function() {
    const vatCheckbox = document.querySelector('[data-vat-checkbox]');
    if (!vatCheckbox || !window.vatCartData) return;

    const subtotalWithVat = document.querySelector('.subtotal-with-vat');
    const subtotalWithoutVat = document.querySelector('.subtotal-without-vat');
    const vatInfoUnchecked = document.querySelector('.vat-info-unchecked');
    const vatInfoChecked = document.querySelector('.vat-info-checked');

    function updateSubtotal() {
      const isChecked = vatCheckbox.checked;
      const hasVat = window.vatCartData.hasVatItems;

      if (isChecked && hasVat) {
        // Checkbox is CHECKED: Show VAT-exclusive subtotal
        subtotalWithVat.style.display = 'none';
        subtotalWithoutVat.style.display = 'inline';
        vatInfoUnchecked.style.display = 'none';
        vatInfoChecked.style.display = 'block';
      } else {
        // Checkbox is UNCHECKED: Show VAT-inclusive subtotal
        subtotalWithVat.style.display = 'inline';
        subtotalWithoutVat.style.display = 'none';
        vatInfoUnchecked.style.display = hasVat ? 'block' : 'none';
        vatInfoChecked.style.display = 'none';
      }

      // Update cart attribute
      const body = JSON.stringify({
        attributes: {
          vat_relief: isChecked ? 'true' : 'false'
        }
      });
      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    }

    // Initial state
    updateSubtotal();

    // Listen for checkbox changes
    vatCheckbox.addEventListener('change', updateSubtotal);
  });

  } catch(e) { console.error(e); }
})();
})();
